import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import WatermassAction from '../actions/WatermassAction'
import i18n from 'simple-react-i18n'
import { push } from '@lagunovsky/redux-react-router'
import { carmencartoWatermassDefaultLink, sandreWatermassDefaultLink } from '../../../../conf/SieauConstants'
import {
    PATH_REFERENCIAL,
    PATH_REFERENCIAL_WATERMASS,
    PATH_REFERENCIAL_WATERMASS_ITEM_NEW,
} from '../../../../home/constants/RouteConstants'
import { find } from 'lodash'
import HomeAction from '../../../../home/actions/HomeAction'
import logoSandre from '../../../../assets/pictures/logo_sandre.png'
import logoCarmen from '../../../../assets/pictures/logos/carmen.png'
import ReferencialAction from '../../../action/ReferencialAction'
import { getDataWithHeaders } from 'utils/ExportDataUtil'
import useTitle from 'utils/customHook/useTitle'
import useActions from 'utils/customHook/useActions'
import { getExportReferencialData, reloadJobSync } from 'referencial/util/ReferencialUtils'
import SearchTable from 'referencial/components/SearchTable'
import { REFERENCIAL_TYPE_NAME, REFERENTIAL_JOBSYNC_ID } from 'referencial/constants/ReferencialConstants'
import JobSyncStatus from '../../JobSyncStatus'

const headers = ['code', 'name', 'euroCode', 'watermassType']

const WatermassesApp = () => {
    const {
        watermasses,
    } = useSelector(store => ({
        watermasses: store.WatermassReducer.watermasses,
    }), shallowEqual)

    const [exportData, setExportData] = useState([])
    const [jobSync, setJobSync] = useState(undefined)

    useEffect(() => {
        reloadJobSync(REFERENTIAL_JOBSYNC_ID.watermass, setJobSync)
    }, [])

    useEffect(() => {
        if (jobSync && jobSync.executions[0]) {
            if (!jobSync.executions[0].statusCode) {
                setTimeout(() => {
                    reloadJobSync(REFERENTIAL_JOBSYNC_ID.watermass, setJobSync)
                }, 5000)
            }
        }
    }, [jobSync])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(WatermassAction.fetchWatermasses())
        dispatch(HomeAction.setHelpLink)
    }, [])

    useTitle(() => [{
        title: i18n.referencials,
        href: PATH_REFERENCIAL,
    }, {
        title: i18n.watermasses,
        href: PATH_REFERENCIAL_WATERMASS,
    }], [])

    useActions(() => {
        return {
            new: () => dispatch(push(PATH_REFERENCIAL_WATERMASS_ITEM_NEW)),
            referencialActions: {
                actions: {
                    export: {
                        data: getDataWithHeaders(exportData, headers),
                        titleFile: i18n.watermassList,
                    },
                    sync: {
                        updateAction: options => dispatch(ReferencialAction.launchSyncJob(REFERENTIAL_JOBSYNC_ID.watermass, options, () => reloadJobSync(REFERENTIAL_JOBSYNC_ID.watermass, setJobSync))),
                    },
                    purge: {
                        onPurge: () => dispatch(WatermassAction.purgeWatermass()),
                    },
                },
            },
            links: [{
                href: carmencartoWatermassDefaultLink,
                img: logoCarmen,
                label: i18n.carmen.toUpperCase(),
            }, {
                href: sandreWatermassDefaultLink,
                img: logoSandre,
                label: i18n.sandre.toUpperCase(),
            }],
        }
    }, [exportData])

    const data = useMemo(() => getExportReferencialData(watermasses), [watermasses])

    return (
        <SearchTable
            useNewTable
            title={i18n.watermassList}
            sessionKey={REFERENCIAL_TYPE_NAME.watermass}
            data={data}
            setExportData={setExportData}
            headers={headers}
            onClick={watermass => dispatch(push(`/referencial/watermass/${watermass.id}/dashboard`))}
            jobSync={<JobSyncStatus jobSync={jobSync}/>}
        />
    )
}

export default WatermassesApp
